(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-filter"] && !Shopify.designMode) return;
  try {
    
  const pageURL = window.location.href;
  const navLinks = document.querySelectorAll('.filter-nav-link');
  const options = document.querySelectorAll('.nav-filter-option');
  const selectElement = document.getElementById('filter-select');

  const getLastPath = (urlStr) => {
    const url = new URL(urlStr);
    const pathname = url.pathname;
    const segments = pathname.split('/').filter(Boolean);
    return segments.pop();
  };

  const lastPath = getLastPath(pageURL);

  navLinks.forEach((link) => {
    link.classList.remove('active');

    if (link.href.includes(lastPath)) {
      link.classList.add('active');
    }
  });

  options.forEach((option) => {
    if (option.value.includes(lastPath)) {
      selectElement.value = option.value;
    }
  });

  selectElement.addEventListener('change', function (event) {
    const selectedValue = event.target.value;
    window.location.href = selectedValue;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filter-navigation"] && !Shopify.designMode) return;
  try {
    
  const urlParams = new URLSearchParams(window.location.search);
  const productType = urlParams.get('filter.p.product_type');
  const tagType = urlParams.get('filter.p.tag');
  const navLinks = document.querySelectorAll('.filter-nav-link');
  const options = document.querySelectorAll('.nav-filter-option');
  const selectElement = document.getElementById('filter-select');
  const headingElement = document.querySelector('.collection-hero__title');
  if (tagType === '' || !tagType) {
    const filterNav = document.getElementById('filter-navigation');
    filterNav.classList.remove('display-none');
  }

  headingElement.innerText = 'All products'
  if(tagType === 'Bestseller'){
    headingElement.innerText = 'Our bestsellers'
  }
  if(tagType === 'Featured'){
    headingElement.innerText = 'Featured'
  }
  if(tagType === 'New'){
    headingElement.innerText = "What's new"
  }
  if(productType === 'Nameplate'){
    headingElement.innerText = 'Nameplates'
  }
  if(productType === 'Wall Stories'){
    headingElement.innerText = 'Wall stories'
  }
  if(productType === 'Decor'){
    headingElement.innerText = 'Decor'
  }
  if(productType === 'Coaster'){
    headingElement.innerText = 'Coasters'
  }
  if(productType === 'Cup'){
    headingElement.innerText = 'Mugs & Bowls'
  }
  if(productType === 'Treat Jar'){
    headingElement.innerText = 'Treat jars'
  }


  if (productType && productType !== '') {
    navLinks.forEach((link) => {
      link.classList.remove('active');
      if (link.href.includes(productType.replace(' ', '+'))) {
        link.classList.add('active');
      }
    });

    options.forEach((option) => {
      if (option.value.includes(productType.replace(' ', '+'))) {
        selectElement.value = option.value;
      }
    });
  } else {
    navLinks[0].classList.add('active');
    selectElement.value = options[0].value;
  }

  selectElement.addEventListener('change', function (event) {
    // Get the selected value from the event target or element properties
    const selectedValue = event.target.value;
    // The element's value property is a shortcut to the selected option's value
    // const selectedValue = this.value;
    window.location.href = selectedValue;
  });

  // Any other JavaScript for this specific section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-navigation"] && !Shopify.designMode) return;
  try {
    
  const urlParams = new URLSearchParams(window.location.search);
  const tagType = urlParams.get('filter.p.tag');
  const tabLinks = document.querySelectorAll('.tab-nav-link');

  const selectElement = document.getElementById('tab-select');
  const options = document.querySelectorAll('.tab-nav-option');

  selectElement.addEventListener('change', function (event) {
    const selectedValue = event.target.value;
    window.location.href = selectedValue;
  });

  if (window.location.href.includes('collections/all')) {
    if (tagType && tagType !== '') {
      tabLinks.forEach((link) => {
        link.classList.remove('active');
        if (link.href.includes(tagType.replace(' ', '+'))) {
          link.classList.add('active');
        }
      });

      options.forEach((option) => {
        if (option.value.includes(tagType.replace(' ', '+'))) {
          selectElement.value = option.value;
        }
      });
    } else {
      tabLinks[0].classList.add('active');
      selectElement.value = options[0].value;
    }
  }

  // Any other JavaScript for this specific section

  } catch(e) { console.error(e); }
})();
})();
